module.exports = __webpack_public_path__ + "static/media/back_mag.08e4fce3.png";